import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LocalStorageService } from "../../../services";
import Iframe from 'react-iframe';
import './boveda.css';

// Validar eliminacion del Archivo...
const BovedaView = () => {
    const location = useLocation()
    const idPrecarga = location?.state?.idPrecarga || 0
    const localStorageService = new LocalStorageService();
    const user = localStorageService.getLocalStorageItem("bovedaToken").user
    const password = localStorageService.getLocalStorageItem("bovedaToken").password
    const [urlDocs] = useState(idPrecarga ? `${process.env.REACT_APP_GRC_BOVEDA_LARAVEL}/login_docs?idPrecarga=${idPrecarga}&user=${user}&password=${password}` : `${process.env.REACT_APP_GRC_BOVEDA_LARAVEL}/login_docs?user=${user}&password=${password}`);
    localStorageService.setLocalStorageItem("bovedaflagActive", true);

    // useEffect(() => {
    //     let isTrue = process.env.REACT_APP_FEATURE_FLAG === "true"
    //     if (isTrue) {
    //         window.open(urlDocs, '_blank');
    //         window.history.back();
    //     }
    // }, [urlDocs])

    return (
        <>
            {urlDocs ?
                <div className="boveda-view-div">
                    <Iframe
                        className="boveda-view-iframe"
                        url={urlDocs}
                        id={urlDocs}
                    />
                </div>
                : null}
        </>
    );
};

export { BovedaView as default };